import type { LayerFilterDef } from '../types/filter.js';

/**
 * Canonical numeric filter shape after migrating legacy `rangeMode` values
 * (`histogram` / `slider` → `range` + `showHistogram`).
 */
export type NormalizedNumericLayerFilterDef = LayerFilterDef & {
  rangeMode: 'range' | 'timeline';
  showHistogram: boolean;
};

/**
 * Migrates persisted filter defs: `histogram` | `slider` | missing → `range` | `timeline`
 * and derives `showHistogram` (default on, except legacy `slider`).
 */
export function normalizeLayerFilterDef(def: LayerFilterDef): NormalizedNumericLayerFilterDef {
  const rm = def.rangeMode;
  let rangeMode: 'range' | 'timeline';
  let showHistogram: boolean;

  if (rm === 'timeline') {
    rangeMode = 'timeline';
    showHistogram = def.showHistogram !== false;
  } else if (rm === 'slider') {
    rangeMode = 'range';
    showHistogram = def.showHistogram === true;
  } else if (rm === 'histogram') {
    rangeMode = 'range';
    showHistogram = def.showHistogram !== false;
  } else if (rm === 'range') {
    rangeMode = 'range';
    showHistogram = def.showHistogram !== false;
  } else {
    rangeMode = 'range';
    showHistogram = def.showHistogram !== false;
  }

  return { ...def, rangeMode, showHistogram };
}
